import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

export interface Props {
  showModal: boolean;
  text: string;
}

const LoadingModal = ({ showModal, text }: Props) => {
  return (
    <Modal id="loading-modal-wrapper" backdrop="static" keyboard={false} show={showModal}>
      <Modal.Body
        id="loading-modal-body"
        className="flex items-center justify-center min-h-[100px]"
      >
        <div
          id="loading-modal-body-wrapper"
          className="flex items-center justify-center gap-4 text-center"
        >
          <Spinner
            id="loading-modal-spinner-border"
            animation="border"
            className="text-[#F89723] w-8 h-8 shrink-0"
          />

          <p
            id="loading-modal-text"
            className="text-[#F89723] font-bold text-xl text-left m-0"
          >
            {text}...
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LoadingModal;
